import { useEffect, useState } from "react";

const THEMES = [
    { value: "night", label: "Night" },
    { value: "business", label: "Dark" },
    { value: "fantasy", label: "Light" },
] as const;

const DEFAULT_THEME = "night";

export function ThemeSelector() {
    const [theme, setTheme] = useState(() => {
        try {
            return localStorage.getItem("theme") || DEFAULT_THEME;
        } catch {
            return DEFAULT_THEME;
        }
    });

    useEffect(() => {
        document.documentElement.setAttribute("data-theme", theme);
        try {
            localStorage.setItem("theme", theme);
        } catch {
            // Private browsing or blocked storage; the theme still applies for this session.
        }
    }, [theme]);

    const selectTheme = (next: string) => {
        // The dropdown is held open by focus, so dismiss it explicitly.
        (document.activeElement as HTMLElement | null)?.blur();
        setTheme(next);
    };

    return (
        <div className="dropdown dropdown-end">
            <div tabIndex={0} role="button" className="btn btn-sm btn-ghost gap-2 font-normal rounded-full">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="5" /><path d="M12 1v2M12 21v2M4.2 4.2l1.4 1.4M18.4 18.4l1.4 1.4M1 12h2M21 12h2M4.2 19.8l1.4-1.4M18.4 5.6l1.4-1.4" /></svg>
                Theme
            </div>
            <ul tabIndex={0} className="dropdown-content z-[1] menu p-2 shadow bg-base-200 rounded-box w-52">
                {THEMES.map(({ value, label }) => (
                    <li key={value}>
                        <button
                            className={theme === value ? "menu-active" : ""}
                            aria-current={theme === value}
                            onClick={() => selectTheme(value)}
                        >
                            {label}
                        </button>
                    </li>
                ))}
            </ul>
        </div>
    );
}
